import { render, staticRenderFns } from "./AccountClaiming.vue?vue&type=template&id=d915cd8e&scoped=true"
import script from "./AccountClaiming.vue?vue&type=script&lang=js"
export * from "./AccountClaiming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d915cd8e",
  null
  
)

export default component.exports